<div *ngIf="episodesList?.length > 0" class="eoc-tout" ngClass.lt-md="mobile">
  <platform-page-container [fullscreen]="false" [contentSpacing]="false">
    <div class="carepath-benefits-container">
      <h2 class="text-bold text-center pad top-3x bottom-3x">
        {{ 'eoc_tout_header' | translate }}
      </h2>
      <div class="subhead margin bottom-4x">
        {{ 'eoc_tout_subhead' | translate }}
      </div>
      <div
        class="columns"
        fxLayout.gt-sm="row"
        fxLayout.lt-md="column"
        fxLayoutGap.gt-sm="16px"
        fxLayoutGap.lt-md="32px"
      >
        <div class="column" fxFlex>
          <div
            fxLayout.gt-sm="row"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="space-between center"
            fxLayoutGap="16px"
          >
            <i class="icon icon-list-4"></i>
            <div fxFlex class="content">
              <h4>{{ 'eoc_tout_benefits_1_title' | translate }}</h4>
              <div [innerHTML]="'eoc_tout_benefits_1_text' | translate"></div>
            </div>
          </div>
        </div>
        <div class="column" fxFlex *ngIf="incentivesEnabled | async">
          <div
            fxLayout.gt-sm="row"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="space-between center"
            fxLayoutGap="16px"
          >
            <i class="icon icon-coins-1 coins-icon"></i>
            <div class="content">
              <h4>{{ 'eoc_tout_benefits_2_title' | translate }}</h4>
              <div [innerHTML]="'eoc_tout_benefits_2_text' | translate"></div>
            </div>
          </div>
        </div>
        <div class="column" fxFlex>
          <div
            fxLayout.gt-sm="row"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="space-between center"
            fxLayoutGap="16px"
          >
            <i class="icon-support"></i>
            <div fxFlex class="content">
              <h4>{{ 'eoc_tout_benefits_3_title' | translate }}</h4>
              <div
                appGtm
                gtmOnClick="a"
                [gtmData]="{ event: 'gtm.episodes.homepage.call_pat' }"
                [innerHTML]="
                  'eoc_tout_benefits_3_text_' +
                    (carepathConfig | async)?.assistance
                    | translate
                      : {
                          member_services_phone:
                            ('member_services_phone' | translate),
                          meg_phone: ('meg_phone' | translate),
                          pat_phone: ('smartshopper_pat_phone' | translate)
                        }
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-procedures-list [list]="episodesList"> </app-procedures-list>
  </platform-page-container>
</div>
